let upperLabelsForScale = {
	1: {
		gravity: 'center',
		channelId: 1,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	2: {
		gravity: 'center',
		channelId: 2,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	3: {
		gravity: 'center',
		channelId: 3,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	4: {
		gravity: 'center',
		channelId: 4,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	5: {
		gravity: 'center',
		channelId: 5,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	6: {
		gravity: 'center',
		channelId: 6,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	7: {
		gravity: 'center',
		channelId: 7,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	8: {
		gravity: 'center',
		channelId: 8,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	9: {
		gravity: 'center',
		channelId: 9,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	10: {
		gravity: 'center',
		channelId: 10,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	}
}

let lowerLabelsForScale = {
	11: {
		gravity: 'center',
		channelId: 11,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	12: {
		gravity: 'center',
		channelId: 12,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	13: {
		gravity: 'center',
		channelId: 13,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	14: {
		gravity: 'center',
		channelId: 14,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	15: {
		gravity: 'center',
		channelId: 15,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	17: {
		gravity: 'center',
		channelId: 17,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	},
	18: {
		gravity: 'center',
		channelId: 18,
		value: 0,
		xOffset: 0,
		yOffset: 7,
		color: 'red',
		font: '12px Arial'
	}
}

export {
	upperLabelsForScale,
	lowerLabelsForScale
}